"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultRippleTheme = void 0;
const defaultRippleTheme = exports.defaultRippleTheme = {
  circleFill: "transparent",
  fill: "--neutral-a16"
};
//# sourceMappingURL=defaultRippleTheme.js.map